import { useQuery } from 'react-query';
import { UserService, ListParams } from '../../services/v1/UserService';

export const useUsers = (params: ListParams) =>
  useQuery({
    queryKey: ['users', params],
    queryFn: () => UserService.list(params),
  });
